import React, { useCallback, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button, Box, Text, getPaletteColor } from 'pcln-design-system'
import { Menu, MenuItem } from 'pcln-menu'

const HighlightSymbolItem = styled(MenuItem)`
  &:not(:hover) {
    & > :first-child {
      & > :first-child {
        color: ${getPaletteColor('primary.base')};
      }
    }
  }
`

const CurrencySelectorWrapper = styled(Box)`
  button {
    padding: 8px;
  }
`

function CurrencySelector({ className, buttonProps, currencies, initialCurrency, onChange }) {
  const [currencyCode, setCurrencyCode] = useState(initialCurrency)
  const onCurrencyCodeChange = useCallback(
    (code) => {
      setCurrencyCode(code)
      onChange && onChange(code)
    },
    [onChange]
  )

  const memoCurrencies = useMemo(
    () =>
      currencies &&
      currencies.map((currency) => {
        const selected = currency.code === currencyCode
        const onClick = () => onCurrencyCodeChange(currency.code)
        return (
          <HighlightSymbolItem key={currency.code} selected={selected} onClick={onClick}>
            <Text width={32} textAlign='center' regular mr={3}>
              {currency.symbol}
            </Text>
            <Text regular>{currency.label}</Text>
          </HighlightSymbolItem>
        )
      }),
    [currencies, currencyCode, onCurrencyCodeChange]
  )

  return (
    <CurrencySelectorWrapper>
      <Menu
        id='currency-selector'
        className={className}
        buttonProps={buttonProps}
        buttonText={currencyCode}
        size={['singleColumn', null, null, 'twoColumns']}
        height={['350px', '500px', '700px', '100%']}
      >
        {memoCurrencies}
      </Menu>
    </CurrencySelectorWrapper>
  )
}

CurrencySelector.displayName = 'CurrencySelector'

CurrencySelector.propTypes = {
  className: PropTypes.string,
  buttonProps: PropTypes.shape(Button.propTypes),
  currencies: PropTypes.array,
  initialCurrency: PropTypes.string,
  onChange: PropTypes.func,
}

CurrencySelector.defaultProps = {
  initialCurrency: 'USD',
}

export default CurrencySelector
